<mat-tab-group [(selectedIndex)]="selectedTabIndex" animationDuration="0ms">
  <mat-tab>
    <ng-template mat-tab-label>
      <i-tabler name="users" class="icon-18 m-r-8"></i-tabler>
      {{ 'LABEL.ACTIVE_PATIENTS' | translate }}
    </ng-template>
    <div class="p-t-16">
      <app-ipd-active-list></app-ipd-active-list>
    </div>
  </mat-tab>
  <mat-tab>
    <ng-template mat-tab-label>
      <i-tabler name="bed" class="icon-18 m-r-8"></i-tabler>
      {{ 'LABEL.ROOM_DASHBOARD' | translate }}
    </ng-template>
    <div class="p-t-16">
      <app-bed-occupancy></app-bed-occupancy>
    </div>
  </mat-tab>
</mat-tab-group>
